import { render } from "./details-modal.vue?vue&type=template&id=a28a6f56&ts=true"
import script from "./details-modal.vue?vue&type=script&lang=ts"
export * from "./details-modal.vue?vue&type=script&lang=ts"

import "./details-modal.vue?vue&type=style&index=0&id=a28a6f56&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__